module.exports = __webpack_public_path__ + "media/components/src/assets/images/blogs/4-866e1150ed2ac7ebb69424ad83bb723a.jpg";